import React, { useContext } from 'react';
import { Home, About, Contact, Portfolio, Skills, Testimonials, Navbar } from './index';
import { themeContext } from '../context/Theme';

const RouteComp = () => {
    const {dark} = useContext(themeContext);
  return (
    <>
      <Navbar/>
      <div className={` px-4 md:px-24 font-sans ${dark ? 'bg-dark text-gray-100': 'bg-slate-100 text-gray-800 '}`}>
        <Home />
        <About />
        <Skills />
        <Portfolio />
        <Testimonials />
        <Contact />
      </div>
    </>
  )
}

export default RouteComp;